module.exports = global["idify"] = require("-!/Users/david.pate/Git/html4-id/node_modules/babel-loader/index.js?{\"presets\":[\"es2015\",\"stage-0\"]}!/Users/david.pate/Git/html4-id/lib/index.js");


/*****************
 ** WEBPACK FOOTER
 ** ./lib/index.js
 ** module id = 0
 ** module chunks = 0
 **/